/**
 * @generated SignedSource<<4d04b6faa48acba0fcb4a8ea9b9f55dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserColumn_PointsAdditionFragment$data = {
  readonly user: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectUserDescription_UserFragment">;
  };
  readonly " $fragmentType": "UserColumn_PointsAdditionFragment";
};
export type UserColumn_PointsAdditionFragment$key = {
  readonly " $data"?: UserColumn_PointsAdditionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserColumn_PointsAdditionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserColumn_PointsAdditionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectUserDescription_UserFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PointsAdditionV2",
  "abstractKey": null
};

(node as any).hash = "807f26b192dc46d08e9c45b35b2a5438";

export default node;
